import { render, staticRenderFns } from "./AppTableElem.vue?vue&type=template&id=5a91ed9e&scoped=true&"
import script from "./AppTableElem.vue?vue&type=script&lang=js&"
export * from "./AppTableElem.vue?vue&type=script&lang=js&"
import style0 from "./AppTableElem.vue?vue&type=style&index=0&id=5a91ed9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a91ed9e",
  null
  
)

export default component.exports